import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import { pickLang, t } from "@/i18n/booking";

// El cliente volvió atrás desde Stripe: se cierra esa reserva sin pagar para que
// sus fechas queden libres y pueda reservar otra vez (con otros extras o fechas).
export default function BookingCancelled() {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = pickLang(location.search);
  const code = new URLSearchParams(location.search).get("code");
  const [retry, setRetry] = useState(`/reservar?lang=${lang}`);
  const done = useRef(false);
  useEffect(() => {
    if (!code || done.current) return;
    done.current = true;
    api.post(`/public/bookings/${code}/abandon`)
      .then(({ data }) => {
        if (data.status === "pending") navigate(`/reservar/resultado?code=${code}&lang=${lang}`, { replace: true });
      })
      .catch(() => {})
      .finally(() => {
        api.get(`/public/bookings/${code}/status`).then(({ data }) => {
          if (!data.vehicle?.slug) return;
          const q = new URLSearchParams({ lang, start: data.pickup_date, end: data.return_date });
          setRetry(`/reservar/${data.vehicle.slug}?${q.toString()}`);
        }).catch(() => {});
      });
  }, [code, lang, navigate]);
  return (
    <PublicLayout lang={lang}>
      {() => (
        <div className="max-w-xl bg-white border border-[#DCD8D0] rounded-xl p-8" data-testid="cancel-box">
          <h1 className="font-display text-2xl font-bold text-[#1A1A1A] mb-2">{t(lang, "cancel_title")}</h1>
          <p className="text-[#5C5C5C] mb-4">{t(lang, "cancel_body")}</p>
          <Link to={retry} className="underline" data-testid="cancel-retry">{t(lang, "retry")}</Link>
        </div>
      )}
    </PublicLayout>
  );
}
